import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { WishlistEntry } from '@wishlist/const';
import { StateWithWishlist, WishlistState } from '../wishlist-state';
import { getWishlistState } from './state.selectors';

const getRemoveWishlistEntryState: MemoizedSelector<
  StateWithWishlist,
  StateUtils.EntityLoaderState<WishlistEntry>
> = createSelector(getWishlistState, (state: WishlistState) => state.removeEntry);

export const getRemoveWishlistEntryLoading = (entry: WishlistEntry): MemoizedSelector<StateWithWishlist, boolean> =>
  createSelector(getRemoveWishlistEntryState, (state: StateUtils.EntityLoaderState<WishlistEntry>) =>
    StateUtils.entityLoadingSelector(state, entry.productCode),
  );
